export default {"src":"/_next/static/media/sell-your-device.1f4602ff.svg","height":27,"width":27};